import axios from 'axios';

// 配置axios实例
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// 添加请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 处理401错误 (未授权)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// 情绪API
export const emotionApi = {
  // 获取所有情绪
  getAllEmotions: () => api.get('/api/emotions'),
  
  // 获取情绪详情
  getEmotion: (id) => api.get(`/api/emotions/${id}`),
  
  // 创建情绪
  createEmotion: (emotionData) => api.post('/api/emotions', emotionData),
  
  // 更新情绪
  updateEmotion: (id, emotionData) => api.put(`/api/emotions/${id}`, emotionData),
  
  // 删除情绪
  deleteEmotion: (id) => api.delete(`/api/emotions/${id}`),
  
  // 按名称搜索情绪
  searchEmotions: (name) => api.get(`/api/emotions/search?name=${name}`),
  
  // 按强度过滤情绪
  getEmotionsByIntensity: (intensity) => api.get(`/api/emotions/intensity/${intensity}`)
};

// 情绪记录API
export const emotionRecordApi = {
  // 获取用户的所有情绪记录
  getUserEmotionRecords: (userId) => api.get(`/api/records/user/${userId}`),
  
  // 获取情绪记录详情
  getEmotionRecord: (id) => api.get(`/api/records/${id}`),
  
  // 创建情绪记录
  createEmotionRecord: (recordData) => {
    console.log('发送创建情绪记录请求', JSON.stringify(recordData, null, 2));
    
    // 验证必须字段
    if (!recordData || !recordData.userId || !recordData.emotionId) {
      console.error('缺少必要字段：userId 或 emotionId');
      return Promise.reject(new Error('缺少必要字段'));
    }
    
    // 确保emotionId是数值类型
    const processedData = {
      ...recordData,
      emotionId: Number(recordData.emotionId)
    };
    
    return api.post('/api/records', processedData, {
      headers: {'Content-Type': 'application/json'},
      timeout: 10000
    });
  },
  
  // 更新情绪记录
  updateEmotionRecord: (id, recordData) => api.put(`/api/records/${id}`, recordData),
  
  // 删除情绪记录
  deleteEmotionRecord: (id) => api.delete(`/api/records/${id}`),
  
  // 更新GPT分析结果
  updateGptAnalysis: (id, analysis) => api.put(`/api/records/${id}/gpt-analysis`, { analysis })
};

// AI分析API
export const aiAnalysisApi = {
  // 获取可用的AI分析提供商
  getAvailableProviders: () => api.get('/api/analysis/providers'),
  
  // 分析文本内容
  analyzeText: (text) => api.post('/api/analysis/text', text, {
    headers: {
      'Content-Type': 'text/plain'
    }
  }),
  
  // 分析并更新情绪记录
  analyzeRecord: (id) => api.post(`/api/analysis/record/${id}`),
};

// 身份验证API
export const authApi = {
  // 登录
  login: (credentials) => api.post('/api/auth/login', credentials),
  
  // 注册
  register: (userData) => api.post('/api/auth/signup', userData),
  
  // 获取当前用户信息
  getCurrentUser: () => api.get('/api/auth/me'),
  
  // 验证令牌
  verifyToken: () => api.get('/api/auth/verify-token')
};

// AI聊天API
export const chatApi = {
  // 发送聊天消息
  sendMessage: (message, sessionId = null) => api.post('/api/chat/message', {
    message,
    sessionId,
    userId: "" // This will be overridden by the backend from the authentication principal
  }),
  
  // 创建新的聊天会话
  createSession: (title = '新的聊天') => api.post('/api/chat/session', null, {
    params: { title }
  }),
  
  // 获取用户的聊天会话列表
  getUserSessions: () => api.get('/api/chat/sessions'),
  
  // 获取会话的聊天历史
  getSessionMessages: (sessionId) => api.get(`/api/chat/session/${sessionId}/messages`),
  
  // 删除聊天会话
  deleteSession: (sessionId) => api.delete(`/api/chat/session/${sessionId}`),
  
  // 更新会话标题
  updateSessionTitle: (sessionId, title) => api.put(`/api/chat/session/${sessionId}/title`, null, {
    params: { title }
  })
};

export default api; 